import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
  Box, Card, CardContent, Typography, Stack, Button, IconButton, Tooltip, Snackbar, Alert,
} from '@mui/material';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { useNavigate } from 'react-router-dom';
import { getBearerToken, postBearerToken } from '../../utils/Apis';
import AppShell from '../../layouts/AppShell';
import { Constants } from '../../utils/Constants';

const A_cloud_recordings = () => {
  // Hosts see only their own rooms' recordings (server-filtered) and can't delete them.
  const isHost = (localStorage.getItem(Constants.USERTYPE) || '') === 'SubAdmin';
  const convertUTCtoIST = (utcDate) => {
    const date = new Date(utcDate);
    return date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
  };

  const navigate = useNavigate();
  const [rows, setrows] = React.useState([]);
  const [toast, setToast] = useState(null);
  const [rendered, setrendered] = useState(0);

  React.useEffect(() => {
    fetch_users();
  }, [rendered]);

  const fetch_users = async () => {
    getBearerToken('cloud_recordings').then((result) => {
      if (result.error == 0) {
        console.log(result);
        setrows(result.data?.meetings);
      } else {
        // notify(JSON.stringify(result.messages))
      }
    });
  };

  const deleteAllFilesOfRecording = async (item) => {
    const ok = window.confirm('Delete this recording? It moves to your Zoom trash, where you can restore it for 30 days.');
    if (!ok) return;
    const result = await postBearerToken('cloud_recordings/delete', { meeting_uuid: item.uuid });
    if (result && result.error === 0) {
      setToast({ severity: 'success', msg: 'Recording moved to the Zoom trash.' });
      fetch_users();
    } else {
      setToast({ severity: 'error', msg: (result && result.message) || 'Could not delete the recording.' });
    }
  };

  const columns = [
    { field: 'id', headerName: 'ID', flex: 1, minWidth: 120 },
    { field: 'topic', headerName: 'Name', flex: 1, minWidth: 150 },
    {
      field: 'link', headerName: 'Link', flex: 1, minWidth: 160, sortable: false, filterable: false,
      renderCell: (params) => (
        <Button
          size="small"
          variant="outlined"
          component="a"
          target="_blank"
          href={params.row?.share_url + '?pwd=' + params.row?.recording_play_passcode}
          startIcon={<OpenInNewRoundedIcon fontSize="small" />}
        >
          View Recordings
        </Button>
      ),
    },
    {
      field: 'start_time', headerName: 'Start Time', flex: 1, minWidth: 180,
      renderCell: (params) => (
        <Typography variant="body2">{convertUTCtoIST(params.row?.start_time)}</Typography>
      ),
    },
    {
      field: 'action', headerName: 'Delete', flex: 1, minWidth: 100, sortable: false, filterable: false,
      renderCell: (params) => (
        <Tooltip title="Delete">
          <IconButton size="small" color="error" onClick={() => deleteAllFilesOfRecording(params.row)}>
            <DeleteOutlineRoundedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <AppShell title="Cloud Recordings" breadcrumb={['Recordings']}>
      <Card>
        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
          <Stack direction="row" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h4">Cloud Recordings</Typography>
          </Stack>
          <Box sx={{ width: '100%' }}>
            <DataGrid
              autoHeight
              rows={rows}
              columns={isHost ? columns.filter((c) => c.field !== 'action') : columns}
              getRowId={(data) => data.uuid}
              disableRowSelectionOnClick
              initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
              pageSizeOptions={[10, 25, 50]}
              sx={{ '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': { outline: 'none' } }}
            />
          </Box>
        </CardContent>
      </Card>
      <Snackbar open={!!toast} autoHideDuration={5000} onClose={() => setToast(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        {toast ? <Alert severity={toast.severity} variant="filled" onClose={() => setToast(null)}>{toast.msg}</Alert> : undefined}
      </Snackbar>
    </AppShell>
  );
};

export default A_cloud_recordings;
